/**
 * Where a signed-out visit was going, carried through the viewer's sign-in (spec
 * retire-edit-mode-fml-page, R5): the protected gate (`ProtectedGate`) hands it to the login page in
 * router state, the
 * login page to Auth0 as `appState`, and `LoginCallbackPage` goes there instead of `/twin` once the
 * user, organisation and legal gate are set up. Without it a deep link such as Admin's Open FML
 * (`/twin?spotlight=…&edit=…`) lost its twin and Edit request at sign-in.
 *
 * Only a path on this site is accepted, so a crafted address cannot send someone to another origin
 * after they sign in: it starts with one `/`, carries no backslash or control character (which some
 * browsers read as a scheme-relative `//`), and is not the login or callback page itself.
 */
const NOT_DESTINATIONS = ['/', '/callback'];

export const safeReturnTo = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  if (!value.startsWith('/') || value.startsWith('//')) return null;
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\\]/.test(value)) return null;
  if (NOT_DESTINATIONS.includes(value.split(/[?#]/)[0])) return null;
  return value;
};

/** The address to come back to: the page's path and query. */
export const returnToOf = (location: { pathname: string; search: string }): string =>
  location.pathname + location.search;

/** The return address carried in router state, if it is one this site may go to. */
export const returnToFromState = (state: unknown): string | null =>
  safeReturnTo((state as { returnTo?: unknown } | null | undefined)?.returnTo);
